'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind();

var NitroNotification = function NitroNotification(_ref) {
  var className = _ref.className,
      label = _ref.label,
      variant = _ref.variant,
      center = _ref.center;

  var notificationClass = cx(['notification', 'notification-' + variant, {
    'notification-center': center
  }, className]);

  return _react2.default.createElement(
    'span',
    { className: notificationClass },
    label
  );
};

NitroNotification.propTypes = {
  label: _react2.default.PropTypes.string.isRequired,
  variant: _react2.default.PropTypes.string,
  center: _react2.default.PropTypes.bool,
  className: _react2.default.PropTypes.string
};

exports.default = NitroNotification;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-notification/NitroNotification.js
// module id = 3022
// module chunks = 4